// apply-discount-cards.js
// Paste after Theme is defined (bottom of theme.liquid). Assumes global everGreenDiscountObj may exist.
//
// NO `import` IN THIS FILE. It is served as type="module" but has never used a bare specifier, and
// it must stay that way: bare specifiers resolve through the import map in snippets/scripts.liquid,
// which needs Safari 16.4+. One unresolved import fails the WHOLE module, and this file also
// rewrites every discounted price on the site — so an import here would take discount display down
// with it on older phones. The Alia queue logic below is therefore inlined rather than imported
// from @theme/alia-popup; keep the two in step by hand.

(function () {

    // ---------------------------------------------------------
    // Recharge Widget Updaters
    // ---------------------------------------------------------
    function updateRechargeWidgetPrice(new_price, updateOneTime = true, updateSub = true) {
        const hostElement = document.querySelector('recharge-subscription-widget');
        if (!hostElement?.shadowRoot) return;

        const shadow_root = hostElement.shadowRoot;
        const price = new_price.trim().startsWith('$') ? new_price : `$${new_price}`;
        setTimeout(() => {
            if (updateSub) {
                // subscription discounted price
                // const subPriceEl = shadow_root.querySelector('.rc-purchase-option__subscription [part="rc-purchase-option__discounted-price"]');
                // if (subPriceEl) {
                //     const node = Array.from(subPriceEl.childNodes).find(n => n.nodeType === Node.TEXT_NODE && /\$\d+/.test(n.textContent));
                //     if (node) node.textContent = `${price}`;
                // }
            }

            if (updateOneTime) {
                // one-time price
                const oneTimeEl = shadow_root.querySelector('.rc-selection__onetime .rc-purchase-option__prices > span.rc-price');
                if (oneTimeEl) {
                    const node = Array.from(oneTimeEl.childNodes).find(n => n.nodeType === Node.TEXT_NODE && /\$\d+/.test(n.textContent));
                    if (node) node.textContent = `${price}`;
                }
            }

        }, 200);
    }


    // ---------- helpers ----------
    const parsePrice = (str) => {
        if (typeof str !== 'string') return NaN;
        // remove currency symbols, commas, 'From', whitespace
        const cleaned = str.replace(/[$,]/g, '').replace(/From/gi, '').trim();
        const n = parseFloat(cleaned);
        return Number.isFinite(n) ? n : NaN;
    };

    const formatPrice = (num) => {
        if (!Number.isFinite(num)) return '';
        return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const getThemeDiscounts = () => {
        try {
            return {
                storeDiscountValue: Theme?.discount?.storeDiscountValue ?? '',
                storeDiscountCode: (Theme?.discount?.storeDiscountCode ?? '').toUpperCase(),
                windowUrlDiscountCode: (Theme?.discount?.windowUrlDiscountCode ?? '').toUpperCase(),
                isCustomer: !!Theme?.discount?.is_customer,
            };
        } catch {
            return { storeDiscountValue: '', storeDiscountCode: '', windowUrlDiscountCode: '', isCustomer: false };
        }
    };

    function doesSubscriptionSelected() {
        const result = { subscription: false, amount: 15 };
        const hostElement = document.querySelector('recharge-subscription-widget');
        if (!hostElement || !hostElement.shadowRoot) return result;

        const shadowRoot = hostElement.shadowRoot;
        const subscriptionElement = shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription');

        if (!subscriptionElement) return result;

        const originalPriceElement = shadowRoot.querySelector(".rc-price.strike-through");
        const salePriceElement = shadowRoot.querySelector(".rc-price:not(.strike-through)");

        if (originalPriceElement && salePriceElement) {
            const originalPrice = parseFloat(originalPriceElement.textContent.replace(/[^0-9.]/g, ""));
            const salePrice = parseFloat(salePriceElement.textContent.replace(/[^0-9.]/g, ""));

            if (!isNaN(originalPrice) && !isNaN(salePrice) && originalPrice > salePrice) {
                result.amount = Number((((originalPrice - salePrice) / originalPrice) * 100).toFixed(2));
            }
        }

        result.subscription = !subscriptionElement.hasAttribute('rc-not-selected');
        return result;
    }
    function rechrageWidgetpriceupdate(card, isSubscription = true, subRealPct = null) {
        const hostElement = document.querySelector('recharge-subscription-widget');
        if (!hostElement || !hostElement.shadowRoot) return;
        const {
            storeDiscountValue,
            storeDiscountCode,
            windowUrlDiscountCode,
            isCustomer
        } = getThemeDiscounts();
        if (!isCustomer) {
            const noDiscount = card.hasAttribute('data-nds') ? true : false;
            if (windowUrlDiscountCode !== "") {
                return false;
            }
            let original_discount = 0;
            let discount_percent_field = card.getAttribute('data-discount-percent') ?? '';
            const discount_percent_compare = card.getAttribute('data-compare-discount') ?? '0';
            const use_compare_at_price = card.hasAttribute('data-use-compare');
            let discountToApply = discount_percent_field !== '' ? discount_percent_field : 25;
            const currentPriceEl = card.querySelector('.js-current-price');
            const originalPriceEl = card.querySelector('.js-original-price');
            const savingBadge = card.querySelectorAll('.js-saving-bdge');
            const savingAmount = card.querySelectorAll('.js-saving-amount');
            if (discountToApply != 0 && !noDiscount) {
                const originalPriceRaw = originalPriceEl.textContent || originalPriceEl.innerText || '';
                let originalPrice = parsePrice(originalPriceRaw);
                let newPrice = originalPrice;
                if (isSubscription) {
                    // Precedencia: Recharge (% real) -> campo del script/customer -> 15
                    const realSubPct = Number(subRealPct);
                    discountToApply = (Number.isFinite(realSubPct) && realSubPct > 0)
                        ? realSubPct
                        : (discount_percent_field !== '' ? discount_percent_field : 15);
                    newPrice = (originalPrice - ((parseFloat(discountToApply) * originalPrice) / 100));
                    let final_discount_usd = parseFloat(newPrice) - parseFloat(originalPrice);
                    final_discount_usd = Math.floor((final_discount_usd).toFixed(0).replace("-", ""));
                    savingAmount.forEach(function (element) {
                        element.innerHTML = `Save $${final_discount_usd}`;
                        element.classList.remove('hidden');
                    })
                    let final_discount = parseFloat(newPrice) / parseFloat(originalPrice);
                    final_discount = 1 - final_discount;
                    final_discount = (final_discount * 100).toFixed(0);
                    savingBadge.forEach(function (element) {
                        element.innerHTML = `(${final_discount}% Off)`;
                        element.style.visibility = 'visible';
                        element.classList.remove('hidden');
                    })
                    updateRechargeWidgetPrice(formatPrice(newPrice), false)
                } else {
                    newPrice = originalPrice;
                    savingBadge.forEach(function (element) {
                        element.innerHTML = '';
                        element.style.visibility = 'hidden';
                        element.classList.remove('hidden');
                    })
                    savingAmount.forEach(function (element) {
                        element.innerHTML = ``;
                        element.classList.add('hidden');
                    })
                    let originalDiscount = card.querySelector('.js-saving-bdge')
                    if (originalDiscount) {
                        let originalDiscountValue = originalDiscount.getAttribute("data-originaldisocunt")
                        if (originalDiscountValue) {
                            if (originalDiscountValue != '' || originalDiscountValue != '0') {
                                newPrice = originalPrice - ((originalPrice * parseFloat(originalDiscountValue)) / 100)
                                originalDiscount.innerHTML = "-" + originalDiscountValue + "%"
                                originalDiscount.style.visibility = 'visible'
                                savingBadge.forEach(function (element) {
                                    element.innerHTML = "(" + originalDiscountValue + "% Off)";
                                    element.style.visibility = 'visible';
                                    element.classList.remove('hidden');
                                })
                                originalPriceEl.classList.remove('hidden')
                                savingAmount.forEach(function (element) {
                                    element.innerHTML = `Save $${Math.ceil(originalPrice - newPrice).toFixed(0)}`;
                                    element.classList.remove('hidden');
                                })
                            }
                        }
                    }
                }
                currentPriceEl.innerHTML = '';
                currentPriceEl.innerHTML = `$${formatPrice(newPrice)}`;
                originalPriceEl.innerHTML = '';
                originalPriceEl.innerHTML = `$${formatPrice(originalPrice)}`;
                isSubscription ? originalPriceEl.classList.remove('hidden') : originalPriceEl.classList.add('hidden');
                if (use_compare_at_price) {
                    originalPriceEl.classList.remove('hidden');
                }
            }
        };
    }

    // ---------- main per-card function (cleaned + defensive) ----------
    function applyDiscountCodeMethod(card, isPDP = false) {
        if (!(card instanceof Element)) return false;
        // avoid repeated processing
        // if (!isPDP && card.dataset.discountApplied === 'true') {
        //     return false;
        // }
        const currentPriceEl = card.querySelector('.js-current-price');
        const originalPriceEl = card.querySelector('.js-original-price');

        if (!currentPriceEl || !originalPriceEl) return false;
        let subscriptionInfo = { subscription: false, amount: 15 };
        let isProductCard = false;
        // Early opt-outs
        if (card.hasAttribute('data-nds')) return false; // no discount
        const noDiscount = card.hasAttribute('data-nds') ? true : false; // kept for parity with your variable names
        if (noDiscount) return false;


        const {
            storeDiscountValue,
            storeDiscountCode,
            windowUrlDiscountCode,
            isCustomer
        } = getThemeDiscounts();
        if (!isCustomer && !windowUrlDiscountCode) return false;
        if (isPDP) {
            isProductCard = card.classList.contains('product-details');
            if (isProductCard) {
                subscriptionInfo = doesSubscriptionSelected();
                rechrageWidgetpriceupdate(card, subscriptionInfo.subscription, subscriptionInfo.amount);
            }
        }
        const tier = card.getAttribute('data-tier') ?? '';
        const use_dollar = card.hasAttribute('data-dollar');
        let discount_percent_field = card.getAttribute('data-discount-percent') ?? '';
        const discount_percent_compare = card.getAttribute('data-compare-discount') ?? '0';
        const use_compare_at_price = card.hasAttribute('data-use-compare');
        let unique_discount = card.getAttribute('data-unique') ?? '';
        const unique_discount_codes = card.getAttribute('data-unique-codes') ?? '';
        const phandle = card.getAttribute('data-handle') ?? '';
        const chandle = card.getAttribute('data-chandle') ?? '';
        const collectionHandles = card.getAttribute('data-collectionobject')
            ? card.getAttribute('data-collectionobject').split(',').map(h => h.trim())
            : [];

        let is_unique_code = false;
        // A customer who arrives with a code the theme has no data for (an expired campaign link,
        // `?discount=LABOR`) is priced with the store code, which assets/discount-keeper.js keeps on
        // their cart. Priced with the URL code, the AirSense 11 showed $753 on the card while the cart
        // charged $699 with BEDTIME (measured live 2026-10-15).
        const urlCodeHasNoData = windowUrlDiscountCode
            && windowUrlDiscountCode !== storeDiscountCode
            && !(typeof everGreenDiscountObj === 'object' && everGreenDiscountObj && everGreenDiscountObj.code === windowUrlDiscountCode);
        const urlDiscountCode = isCustomer && urlCodeHasNoData ? '' : windowUrlDiscountCode;

        // A group's `fixed_price` is what the product's BASE variant sells for; Discount Kit takes
        // that same amount off every variant. Subtracting it from this card's own price instead
        // priced every variant at the fixed price: AirSense 11 ClimateLineAir showed $699 with
        // `?discount=BEDTIME` and the cart charged $745 (measured live 2026-10-15). The base comes
        // from snippets/discount-attribute.liquid, the same one its store-code branch uses.
        const fixedPriceAmountOff = (fixedPrice) => {
            const baseCents = Number(use_compare_at_price && card.dataset.baseCompare ? card.dataset.baseCompare : card.dataset.basePrice);
            const base = baseCents > 0
                ? baseCents / 100
                : parsePrice(originalPriceEl.textContent || originalPriceEl.innerText || '');
            return Number((base - Number(fixedPrice)).toFixed(2));
        };

        if (unique_discount_codes && urlDiscountCode && unique_discount_codes.includes(urlDiscountCode) && unique_discount) {
            is_unique_code = true;
        }
        if (!urlDiscountCode && storeDiscountCode && unique_discount_codes && unique_discount_codes.includes(storeDiscountCode) && unique_discount) {
            is_unique_code = true;
        }

        // evergreen override handling (keeps your logic)
        let discountToApply = 0;
        let useDollar = false;

        if (typeof everGreenDiscountObj === 'object' && everGreenDiscountObj && everGreenDiscountObj.code === urlDiscountCode) {
            discountToApply = everGreenDiscountObj.store || 0;
            useDollar = !!everGreenDiscountObj.show_in_dollar;

            for (const group of (everGreenDiscountObj.groups || [])) {
                // product override
                if (Array.isArray(group.products) && group.products.length > 0) {
                    const prod = group.products.find(p => String(p.handle) === String(phandle));
                    if (prod) {
                        if (prod.fixed_price !== '') {
                            const uniqueVal = fixedPriceAmountOff(prod.fixed_price);
                            unique_discount = uniqueVal;
                            discountToApply = unique_discount;
                            is_unique_code = true;
                        } else {
                            useDollar = !!prod.dollar_amount;
                            if (useDollar) {
                                unique_discount = prod.discount_amount;
                                is_unique_code = true;
                            } else {
                                discount_percent_field = prod.discount_amount;
                            }
                            discountToApply = prod.discount_amount;
                        }
                        break;
                    }
                } else {
                    // collection override
                    const col = Array.isArray(group.collections) ? group.collections.find(c => collectionHandles.includes(c.handle)) : null;
                    if (col) {
                        if (col.fixed_price !== '') {
                            const uniqueVal = fixedPriceAmountOff(col.fixed_price);
                            unique_discount = uniqueVal;
                            discountToApply = unique_discount;
                            is_unique_code = true;
                        } else {
                            useDollar = !!col.dollar_amount;
                            discountToApply = col.discount_amount;
                            if (useDollar) {
                                unique_discount = col.discount_amount;
                                is_unique_code = true;
                            } else {
                                discount_percent_field = col.discount_amount;
                            }
                        }
                        break;
                    }
                }
            }
        }

        // fallback logic (store/customer/url)
        if (!discountToApply || discountToApply == 0) {
            if (unique_discount_codes && urlDiscountCode && unique_discount && unique_discount_codes.includes(urlDiscountCode)) {
                discountToApply = parseFloat(unique_discount);
            }

            if (storeDiscountValue) {
                if (isCustomer) {
                    discountToApply = parseFloat(tier || storeDiscountValue);
                    if (discount_percent_field) discountToApply = parseFloat(discount_percent_field);
                } else {
                    if (urlDiscountCode === storeDiscountCode) {
                        discountToApply = parseFloat(tier || storeDiscountValue);
                        if (discount_percent_field) discountToApply = parseFloat(discount_percent_field);
                    }
                }
            }
        }

        let baseDiscountToApply = discountToApply;

        // If nothing to apply, exit
        if (!discountToApply || discountToApply == 0) {
            return false;
        }

        // Now compute and render
        const originalPriceRaw = originalPriceEl.textContent || originalPriceEl.innerText || '';
        let originalPrice = parsePrice(originalPriceRaw);
        if (use_compare_at_price && discount_percent_compare !== '0') {
            originalPrice = parsePrice(originalPriceRaw);
        }

        if (!Number.isFinite(originalPrice) || originalPrice <= 0) return false;

        const productPriceEl = currentPriceEl;
        const savingBadge = card.querySelector('.js-saving-bdge');
        const savingAmount = card.querySelector('.js-saving-amount');

        let newPrice = originalPrice;
        let stickyBar = null;

        // Calculate newPrice based on discount type
        if (is_unique_code) {
            const uniq = Number(unique_discount) || 0;
            newPrice = originalPrice - uniq;
        } else {
            // percent discount
            /*
            // If subscription selected then discount is 30%
            if (subscriptionInfo.subscription) {
                discountToApply = 30;
            }
            */
            // Precedencia: Recharge (% real leido del widget) -> campo del script/customer -> 15
            if (subscriptionInfo.subscription) {
                const realSubPct = Number(subscriptionInfo.amount);
                discountToApply = (Number.isFinite(realSubPct) && realSubPct > 0)
                    ? realSubPct
                    : (discount_percent_field !== '' ? discount_percent_field : 15);
            }
            const pct = Number(discountToApply) || 0;
            newPrice = originalPrice - ((pct * originalPrice) / 100);
        }
        // Shared UI Calculations
        const final_discount_percent = Math.round((1 - (newPrice / originalPrice)) * 100);
        // Whole dollars, rounded down, as before — except under $10, where the cents stay: "Save $0"
        // on a $2.69 filter (real saving $0.90, measured live 2026-10-15) read as no discount at all.
        const savedAmount = Math.round((originalPrice - newPrice) * 100) / 100;
        const final_discount_usd = savedAmount < 10
            ? formatPrice(savedAmount).replace(/\.00$/, '')
            : Math.floor(savedAmount);

        // Update Card Prices
        productPriceEl.textContent = `$${formatPrice(newPrice)}`;
        originalPriceEl.textContent = `$${formatPrice(originalPrice)}`;

        // Update Card Badges
        if (savingBadge) savingBadge.textContent = `(${final_discount_percent}% off)`;
        if (savingAmount) savingAmount.textContent = `Save $${final_discount_usd}`;

        // Update Sticky Bar (if PDP)
        if (isPDP && isProductCard) {
            stickyBar = document.querySelector('.sp-product__stky-atc');
            if (stickyBar) {
                stickyBar.querySelectorAll('.js-saving-bdge').forEach(function (element) {
                    element.innerHTML = `(${final_discount_percent}% off)`;
                    element.style.visibility = 'visible';
                    element.classList.remove('hidden');
                });
                stickyBar.querySelectorAll('.js-saving-amount').forEach(function (element) {
                    element.innerHTML = `Save $${final_discount_usd}`;
                    element.classList.remove('hidden');
                });
                stickyBar.querySelectorAll('.js-current-price').forEach(function (element) {
                    element.innerHTML = `$${formatPrice(newPrice)}`;
                    element.classList.remove('hidden');
                });
                stickyBar.querySelectorAll('.js-original-price').forEach(function (element) {
                    element.innerHTML = `$${formatPrice(originalPrice)}`;
                    element.classList.remove('hidden');
                });
            }
        }
        // reveal UI
        productPriceEl.classList.remove('hidden');
        originalPriceEl.classList.remove('hidden');
        const fromPrice = card.querySelector('.from_price');
        if (fromPrice) fromPrice.classList.add('has-discount');
        if (savingBadge) {
            savingBadge.style.visibility = 'visible';
            savingBadge.style.width = 'fit-content';
            savingBadge.classList.remove('hidden');
        }
        if (savingAmount) savingAmount.classList.remove('hidden');

        // mark as applied
        card.dataset.discountApplied = 'true';
        if (isPDP && isProductCard) {
            let hostElement = document.querySelector('recharge-subscription-widget');
            if (hostElement) {
                let shadow_root = hostElement.shadowRoot;

                let subPriceCalc = originalPrice;
                let oneTimePriceCalc = originalPrice;

                if (is_unique_code) {
                    const uniq = Number(unique_discount) || 0;
                    subPriceCalc = originalPrice - uniq;
                    oneTimePriceCalc = originalPrice - uniq;
                } else {
                    const oneTimePct = Number(baseDiscountToApply) || 0;
                    oneTimePriceCalc = originalPrice - ((oneTimePct * originalPrice) / 100);
                    // subPriceCalc = originalPrice - ((30 * originalPrice) / 100);
                    const realSubPct = Number(subscriptionInfo.amount);
                    let subPercent = (Number.isFinite(realSubPct) && realSubPct > 0)
                        ? realSubPct
                        : (discount_percent_field !== '' ? Number(discount_percent_field) : 15);
                    subPriceCalc = originalPrice - ((subPercent * originalPrice) / 100);
                }

                updateRechargeWidgetPrice(formatPrice(oneTimePriceCalc), true, false);
                updateRechargeWidgetPrice(formatPrice(subPriceCalc), false, true);

                // UpdateRechargeSub(shadow_root, '30%');
                let subPercentStr = discount_percent_field !== '' ? `${discount_percent_field}%` : '15%';
                // UpdateRechargeSub(shadow_root, subPercentStr);
            }
        }
        return true;
    }

    // ---------- helpers to run across cards ----------
    const applyToAllProductCards = (root = document) => {
        const container = (root instanceof Element || root instanceof Document) ? root : document;
        const productCards = container.querySelectorAll('.js-product-card'); // selectors: adapt to your theme
        let count = 0;
        let isPDP = document.body.classList.contains('sp-product-page');
        for (const card of productCards) {
            if (applyDiscountCodeMethod(card, isPDP)) count++;
        }
        return count;
    };

    // Debounce helper (per-root)
    const _debounceMap = new WeakMap();
    const applyToCardsDebounced = (root = document, wait = 120) => {
        const prev = _debounceMap.get(root);
        if (prev) clearTimeout(prev);
        const t = setTimeout(() => {
            applyToAllProductCards(root);
            _debounceMap.delete(root);
        }, wait);
        _debounceMap.set(root, t);
    };

    // ---------- auto-run if discount present (non-blocking) ----------
    // Use same detection as discount-keeper
    const { windowUrlDiscountCode, isCustomer } = getThemeDiscounts();

    if (windowUrlDiscountCode != '' || (typeof Theme !== 'undefined' && Theme?.discount?.storeDiscountCode) || isCustomer) {
        // schedule on idle for performance
        if (typeof window.requestIdleCallback === 'function') {
            requestIdleCallback(() => applyToAllProductCards(document), { timeout: 1500 });
        } else {
            setTimeout(() => applyToAllProductCards(document), 30);
        }
        const storeCode = Theme?.discount?.storeDiscountCode || '';
        // Show the code when the URL carries the matching discount, OR when a
        // logged-in customer has a store discount available (no URL param needed).
        const codeToShow = (windowUrlDiscountCode && windowUrlDiscountCode === storeCode)
            ? windowUrlDiscountCode
            : (isCustomer && storeCode ? storeCode : '');
        if (codeToShow) {
            document.querySelectorAll('.js-open-popup').forEach(el => {
                el.classList.add('hidden');
            });
            document.querySelectorAll('.js-discount-code').forEach(el => {
                el.innerHTML = 'DISCOUNT CODE: ' + codeToShow.toUpperCase();
                el.classList.add('show');
            });
        }
    }
    attachPopupHandler(
        document.querySelectorAll('.js-open-popup'),
        () =>
            (windowUrlDiscountCode || '').toUpperCase() !==
            (Theme?.discount?.storeDiscountCode || '').toUpperCase() &&
            !isCustomer
    );
    attachPopupHandler(
        document.querySelectorAll('.js-open-popup-nonloggedin'),
        () =>
            (windowUrlDiscountCode || '').toUpperCase() !==
            (Theme?.discount?.storeDiscountCode || '').toUpperCase() &&
            !isCustomer
    );
    attachPopupHandler(
        document.querySelectorAll('[data-open-popup]')
    );

    // ---------- expose API ----------
    window.Theme = window.Theme || {};
    window.Theme._applyDiscountToCards = applyToAllProductCards;           // immediate for subtree or whole page
    window.Theme._applyDiscountToCardsDebounced = applyToCardsDebounced;  // debounced
    document.addEventListener('variant:update', function (event) {
        let isPDP = document.body.classList.contains('sp-product-page');
        if (isPDP) {
            applyToAllProductCards(document.querySelector('.sl-product__wrapper'));
        } else {
            applyToAllProductCards(event.target.parentElement.parentElement.parentElement.parentElement);
        }

    });
    /**
     * Binds the "open the Alia popup" CTAs (`.js-open-popup`, `.js-open-popup-nonloggedin`,
     * `[data-open-popup]` — the Fall Sale bar, the small-USP link, the mobile menu footer).
     *
     * Opening goes through `@theme/alia-popup`, never `window.alia.push` guarded by
     * `if (window.alia)`. Measured on live 2026-09-15: `window.alia` is still `undefined` for the
     * first seconds of a PDP load (Alia boots through a ScriptTag and several serial round trips),
     * so that guard was false, the handler ran `preventDefault()` and then did nothing at all — the
     * tap was swallowed and no popup ever appeared. On a phone that dead window covers exactly when
     * a shopper taps the offer banner they just saw. Creating Alia's replay queue when the SDK is
     * not up yet is what makes the tap survive until it boots.
     */
    function attachPopupHandler(elements, condition = () => true) {
        elements.forEach(el => {
            if (condition(el)) {
                el.addEventListener('click', e => {
                    try {
                        e.preventDefault();
                        // Same three states assets/alia-popup.js documents: `window.alia` is
                        // undefined until Alia's script lands, a plain array acting as a replay
                        // queue until its SDK initialises, and the SDK object after that. Creating
                        // the queue is what makes an early tap survive instead of being swallowed
                        // by the preventDefault above.
                        const alia = window.alia;
                        if (!alia || Array.isArray(alia)) {
                            window.alia = alia || [];
                        }
                        window.alia.push({ type: 'open' });
                    } catch (error) {
                        console.error('apply-discount-cards popup click handler failed:', error);
                    }
                });
            }
        });
    }
    // observer to wait for widget load
    function bindRechargeEvents() {
        const {
            windowUrlDiscountCode,
            isCustomer
        } = getThemeDiscounts();
        const host = document.querySelector('recharge-subscription-widget');
        if (!host?.shadowRoot) return;

        const shadow_root = host.shadowRoot;
        if (shadow_root) {
            // Forzamos el label del widget nativo para TODOS los usuarios (invitados incluidos),
            // usando el % real leido de la opcion de suscripcion (Recharge = fuente de verdad).
            forceRechargeLabel(shadow_root);
            const rechargeOption = shadow_root.querySelectorAll('.rc-purchase-option');
            if (rechargeOption.length > 0) {
                attachSubscriptionChangeHandlers(shadow_root, rechargeOption)
            } else {
                registerSubwidget(shadow_root)
            }
        } else {
            // Apply discount to product card
            // if (document.querySelector(".js-product-card.product-details")) {
            //     applyDiscountCodeMethod(document.querySelector(".js-product-card.product-details"), true);
            // }
        }
    }
    function attachSubscriptionChangeHandlers(shadow_root, rechargeOption) {
        if (rechargeOption.length > 0) {
            const {
                windowUrlDiscountCode,
                isCustomer
            } = getThemeDiscounts();
            if (isCustomer || windowUrlDiscountCode !== '') {
                applyDiscountCodeMethod(document.querySelector(".js-product-card.product-details"), true);
            }
            rechargeOption.forEach(function (element) {
                element.addEventListener('change', function (event) {
                    let currentTarget = event.currentTarget;
                    if (currentTarget.classList.contains('rc-purchase-option__subscription')) {
                        // Re-forzamos el label tras el re-render del widget (Recharge puede repintarlo).
                        setTimeout(function () { forceRechargeLabel(shadow_root); }, 200);
                    }
                    window.Theme._applyDiscountToCards(document.querySelector(".sl-product__wrapper"));
                });
            });
        }
    }
    function registerSubwidget(shadow_root) {
        if (shadow_root) {
            setTimeout(function () {
                const rechargeOption = shadow_root.querySelectorAll('.rc-purchase-option');
                if (rechargeOption.length > 0) {
                    attachSubscriptionChangeHandlers(shadow_root, rechargeOption)
                }
            }, 400)
        }
    }
    // Lee el % real de descuento de la opcion de SUSCRIPCION del widget nativo de Recharge,
    // acotado a esa opcion (no depende de cual este seleccionada). Devuelve null si no se puede leer.
    function getSubscriptionDiscountPct() {
        const host = document.querySelector('recharge-subscription-widget');
        if (!host?.shadowRoot) return null;
        const subOption = host.shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription');
        if (!subOption) return null;
        const strikeEl = subOption.querySelector('.rc-price.strike-through');
        const saleEl = subOption.querySelector('.rc-price:not(.strike-through)');
        if (!strikeEl || !saleEl) return null;
        const original = parseFloat(strikeEl.textContent.replace(/[^0-9.]/g, ''));
        const sale = parseFloat(saleEl.textContent.replace(/[^0-9.]/g, ''));
        if (!Number.isFinite(original) || !Number.isFinite(sale) || original <= sale) return null;
        return Math.round(((original - sale) / original) * 100);
    }

    // Fuerza el label del widget nativo para que coincida con el % real de Recharge.
    // Si no se puede leer el %, NO escribe nada (mejor el label de Recharge que uno inventado).
    function forceRechargeLabel(shadow_root) {
        const pct = getSubscriptionDiscountPct();
        if (pct && pct > 0) {
            UpdateRechargeSub(shadow_root, `${pct}%`);
        }
    }

    function UpdateRechargeSub(shadow_root, SavingPercent = '15%') {
        const rcBenefitsElement = shadow_root.querySelector('rc-benefits');
        if (rcBenefitsElement && rcBenefitsElement.shadowRoot) {
            const firstBenefit = rcBenefitsElement.shadowRoot.querySelector('ul li');
            if (firstBenefit) {
                firstBenefit.innerHTML = `Save ${SavingPercent}`;
            }
        }
        shadow_root.querySelectorAll('.rc-purchase-option__badge').forEach(el => {
            const matches = el.innerHTML.match(/<!--\?lit\$\d+\$-->/g);
            if (matches && matches.length > 0) {
                el.innerHTML = `${matches[0]}Save ${SavingPercent}`;
            } else {
                el.innerHTML = `Save ${SavingPercent}`;
            }
        });
        let selling_plans = shadow_root.querySelector('rc-selling-plans')
        if (selling_plans && selling_plans.shadowRoot) {
            let sellingPlansShadowroot = selling_plans.shadowRoot;
            if (sellingPlansShadowroot) {
                sellingPlansShadowroot.querySelectorAll('.rc-plans-button__discount').forEach(el => {
                    const matches = el.innerHTML.match(/<!--\?lit\$\d+\$-->/g);
                    if (matches && matches.length > 0) {
                        el.innerHTML = `${matches[0]}Save ${SavingPercent}`;
                    } else {
                        el.innerHTML = `Save ${SavingPercent}`;
                    }
                });
            }
        }
    }
    let attempts = 0;
    const maxAttempts = 10;
    const rechargeObserver = new MutationObserver(() => {
        attempts++;
        const widget = document.querySelector('recharge-subscription-widget');
        if (widget) {
            // Look for shadow root
            if (widget?.shadowRoot) {
                setTimeout(function () {
                    const rechargeOption = widget.shadowRoot.querySelectorAll('.rc-purchase-option');
                    if (rechargeOption.length > 0) {
                        bindRechargeEvents()
                        rechargeObserver.disconnect();
                    }
                }, 100)
            }
        }
        if (attempts >= maxAttempts) {
            rechargeObserver.disconnect();
            console.warn('Recharge widget not found after max attempts.');
        }
    });

    rechargeObserver.observe(document.body, { childList: true, subtree: true });
})();
